//@ts-nocheck
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authSlice, { resetAuthSlice } from "./authSlice";
import siteSlice, { resetSiteSlice } from "./siteSlice";
import floorSlice, { resetFloorSlice } from "./floorSlice";
import editorSlice from "./EditoreSlice";
import mapObjectSlice, { resetMapObject3dSlice } from "./mapObjectSlice";
import mutliLanguageSlice, { resetMultilanguageSlice } from "./mutliLanguageSlice";
import apiKeySlice, { resetApiKeySlice } from './apiKeySlice';
import nodesSlice from './nodesSlice';
import feedbackSlice, { resetFeedbackSlice } from './feedbackSlice';
import visitorSlice, { resetVisitorSlice } from './visitorSlice';
const rootReducer = combineReducers({
    auth: authSlice,
    site: siteSlice,
    floors: floorSlice,
    editor: editorSlice,
    mapObject: mapObjectSlice,
    multiLanguage: mutliLanguageSlice,
    apiKey: apiKeySlice,
    nodes: nodesSlice,
    feedback: feedbackSlice,
    visitor: visitorSlice
});
const persistConfig = {
    key: "beco_dashboard",
    storage,
};
const persistedReducer = persistReducer(persistConfig, rootReducer);
// @ts-ignore
const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }),
});
const persistor = persistStore(store);
export const clearPersist = () => {
    persistor.pause();
    persistor.flush().then(() => {
        // localStorage.removeItem("token");
        storage.removeItem("persist:beco_dashboard");
        return persistor.purge();
    });
};
export const resetAllStates = (dispatch) => {
    dispatch(resetAuthSlice());
    dispatch(resetSiteSlice());
    dispatch(resetFloorSlice());
    dispatch(resetMapObject3dSlice());
    dispatch(resetMultilanguageSlice());
    dispatch(resetApiKeySlice());
    dispatch(resetFeedbackSlice());
    dispatch(resetVisitorSlice());
};
export { store, persistor };
